import { useState, useEffect, useMemo, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button } from 'react-bootstrap';

import { getDeploymentNotifications } from '../../services/notifications.js';
import List from '../controls/List.jsx';
import UserNotifications from './users/UserNotifications.jsx';
import SendNotifications from './send/SendNotifications.jsx';
import ManageNotifications from './manage/ManageNotifications.jsx';
import { NotificationsProvider } from './NotificationsContext.js';

const NotificationsTab = () => {
  const { objectType, id, objectSubType = 'manage', } = useParams();
  const history = useHistory();
  const [translate] = useTranslation();

  const baseUrl = `/${objectType}/${id}`;

  const [isLoading, setIsLoading] = useState(true);
  const [notificationsData, setNotificationsData] = useState({});

  const refreshData = useCallback(() => {
    setIsLoading(true);

    getDeploymentNotifications({
      deploymentId: id,
    }).then((res) => {
      if (!res.error) {
        setNotificationsData(res.data);
      }

      setIsLoading(false);
    });
  }, [id]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const NOTIFICATIONS_TABS = useMemo(() => {
    return {
      manage: {
        _id: 'manage',
        title: translate('OTM_NOTIFICATIONS_MANAGE'),
      },
      users: {
        _id: 'users',
        title: translate('OTM_NOTIFICATIONS_USERS_AND_REGISTRATIONS'),
      },
      send: {
        _id: 'send',
        title: translate('OTM_NOTIFICATIONS_SEND'),
      },
    };
  }, [translate]);

  const details = useMemo(() => {
    if (!isLoading) {
      return (
        <div className='col-11 h-100'>
          {(objectSubType === '' || objectSubType === 'manage') && <ManageNotifications />}
          {objectSubType === 'users' && <UserNotifications />}
          {objectSubType === 'send' && <SendNotifications />}
        </div>
      );
    }

    return <div className="col-11 h6">
      <div className="spinner-border spinner-border-sm text-secondary" />
      <label className="ps-2">{translate("OTM_LOADING...")}</label>
    </div>
  }, [isLoading, objectSubType, translate]);

  const selectTab = useCallback((eventKey) => {
    const userIds = Object.keys(notificationsData);

    switch (eventKey) {
      case 'send':
        history.push(`${baseUrl}/${eventKey}`);
        break;
      case 'users':
        history.push(`${baseUrl}/${eventKey}/${userIds.at(0) || ''}`);
        break;
      case 'manage':
      case '':
      default:
        history.push(`${baseUrl}/${eventKey}`);
        break;
    }
  }, [notificationsData, baseUrl, history]);

  return (
    <NotificationsProvider notificationsData={notificationsData} refreshData={refreshData} isLoading={isLoading} >
      <div className='row h-100 mt-3 overflow-hidden'>
        <div className='col-1 fs-7 border-end'>
          <List
            data={Object.values(NOTIFICATIONS_TABS)}
            attr='title'
            selectedElement={objectSubType}
            onClick={isLoading ? null : selectTab}
          />
          <div className='border-top border-accenture mt-2'>
            <Button
              size="sm"
              variant='primary'
              className='mt-2 w-100'
              onClick={refreshData}
            >
              {translate('OTM_NOTIFICATIONS_REFRESH')}
            </Button>
          </div>
        </div>
        {details}
      </div>
    </NotificationsProvider>
  );
};

export default NotificationsTab;